// extracted by mini-css-extract-plugin
module.exports = {"root":"NotCheckedCell_root__1ucJo"};